import { render, staticRenderFns } from "./PaymentConfirmationDocument.vue?vue&type=template&id=64ad4bc6&scoped=true"
import script from "./PaymentConfirmationDocument.vue?vue&type=script&lang=js"
export * from "./PaymentConfirmationDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ad4bc6",
  null
  
)

export default component.exports